import { sizes, colors } from './tokens';

export default {
    icon: {
        verticalAlign: 'middle',
        pointerEvents: 'all',
        '& path': {
            stroke: 'currentColor',
        },
    },
    iconFill: {
        verticalAlign: 'middle',
        pointerEvents: 'all',
        '& path': {
            fill: 'currentColor',
        },
    },
    illustration: {
        verticalAlign: 'middle',
        pointerEvents: 'all',
    },
    ...Object.keys(sizes).reduce((acc, item) => {
        const value = `${sizes[item]}px`;
        acc[`icon-sz--${item}`] = {
            width: value,
            height: value,
        };
        return acc;
    }, {}),
    ...Object.keys(colors).reduce((acc, item) => {
        acc[`icon-cl--${item}`] = { color: colors[item] };
        return acc;
    }, {}),
};